import { removeAccents, toImageSrc } from "@/lib/utils"
import { EventData } from "@/types/event"
import type { EventItem } from "../types"

export const getEventUrl = (name: string, id: number): string => {
  const slug = removeAccents(name)
  return `/events/${slug}-${id}`
}

export const getImageUrl = (url: string | undefined, provider: string | undefined): string => {
  if (!url) return ""

  // If provider is external (like cloudinary), return full URL if already has protocol
  if (provider && provider !== "local") {
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url
    }
    // For cloudinary or other external providers without protocol
    return `https://${url}`
  }

  // For local provider, use toImageSrc to add API URL prefix
  return toImageSrc(url)
}

export const mapEventToItem = (event: EventData): EventItem => {
  const coverData = event.attributes?.cover?.data
  const coverUrl = coverData?.attributes?.url ?? ""
  const coverProvider = coverData?.attributes?.provider ?? "local"

  return {
    id: event.id,
    name: event.attributes?.name ?? "",
    date: event.attributes?.date ?? null,
    shortDescription: event.attributes?.shortDescription ?? null,
    coverUrl: getImageUrl(coverUrl, coverProvider),
    coverProvider,
  }
}
